import getWithToken from './base/get-with-token'

const getUserPermissions = getWithToken('/user-permission')

export default getUserPermissions